import { css } from 'styled-components';

/**
 * This should be removed when entire application has been converted to React.
 * Then we can use a CSS reset of some kind.
 */
export const reset = css`
  // Bump up specificity, to override default css set outside react.
  all: revert;

  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'MontSerrat';
`;
